// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".holidayguru .hg-search-tabs .buttons:not(:last-child){margin-bottom:0}.holidayguru .hg-search-tabs{width:100%;position:relative;z-index:20}.holidayguru .hg-search-tab-panel{box-shadow:0 1px 7px 0 rgba(0,0,0,.15)}", ""]);
// Exports
module.exports = exports;
